module.exports = __webpack_public_path__ + "static/img/TOBY-WHAN.90bc7b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TOBY-WHAN.jpg
// module id = HLJY
// module chunks = 0